import { render } from "./CardPlayer.vue?vue&type=template&id=321ef7d8"
import script from "./CardPlayer.vue?vue&type=script&lang=js"
export * from "./CardPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__